<script>
import emitter from '@/modules/events/emitter'
import eventKinds from '@/modules/events/eventKinds'
import { $axios } from '@/modules/http/axios'
import Swal from 'sweetalert2'

export default {
  name: 'SelectTrailerParkingModal',
  data () {
    return {
      trailer: null,
      vehicle: null,
      parkingSearchText: '',
      parkings: [],
      filteredParkings: [],
      selectedParking: 0
    }
  },
  created () {
    this.fetchParkings()
    emitter.on(eventKinds.selectTrailerParkingModalRequested, e => {
      this.trailer = e.trailer
      this.vehicle = e.vehicle
    })
  },
  methods: {
    filterParkings () {
      setTimeout(() => {
        this.filteredParkings = []
        if (this.parkingSearchText.length) {
          this.filteredParkings = this.parkings.filter(p => p.name.toLowerCase().includes(this.parkingSearchText.toLowerCase()))
          this.sortParkings()
        }
      }, 1000)
    },
    sortParkings () {
      this.filteredParkings.sort((a, b) => a.name.localeCompare(b.name))
      this.parkings.sort((a, b) => a.name.localeCompare(b.name))
    },
    async fetchParkings () {
      this.parkings = (await $axios.get('Parking')).data
      this.sortParkings()
    },
    async detachTrailer () {
      const parking = this.selectedParking
      const postData = { semitrailerId: this.trailer.id, parkingId: parking }

      const parkingToCheckVisibility = (await $axios.get(`Parking/${parking}`)).data

      if (parkingToCheckVisibility.hidden) {
        await $axios.put(`Parking/${parkingToCheckVisibility.id}`, { hidden: false })
      }

      try {
        await $axios.post(`Vehicle/Vehicle/${this.vehicle.id}/Semitrailer/Unassign`, postData)
        emitter.emit('vehicleChanged', { vehicleId: this.trailer.id })
        emitter.emit('trailerDetached')
        document.getElementById('select-trailer-parking-modal-close-btn').click()
        await Swal.fire(`Odpięto naczepę od ciągnika ${this.vehicle.plateNumber}`, '', 'success')
      } catch (e) {
        await Swal.fire('Błąd podczas odpinania naczepy od ciągnika', '', 'error')
      }
    }
  }
}
</script>

<template>
  <div class="modal fade" id="selectTrailerParkingModal" tabindex="-1" aria-labelledby="selectTrailerParkingModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="selectTrailerParkingModalLabel">
            Wybierz docelowy parking dla naczepy <span v-if="trailer">{{ trailer.plateNumber }}</span>
          </h5>
          <button id="select-trailer-parking-modal-close-btn" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body" v-if="trailer">
          <div class="text-center fw-bolder mb-1">
            Lista dostępnych parkingów
          </div>
          <input type="text" placeholder="Filtruj parkingi" class="form-control my-1" v-model="parkingSearchText" @input="filterParkings">
          <select class="form-select my-1" v-model="selectedParking">
            <option :value="0" selected>-- Wybierz parking --</option>
            <option v-for="parking in filteredParkings.length ? filteredParkings : parkings" :key="parking.id" :value="parking.id">
              {{ parking.name }}
            </option>
          </select>
          <div class="text-center">
            <button class="btn btn-primary d-block w-100" @click="detachTrailer">
              Zatwierdź
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
